export default "__VITE_ASSET__CAFvmcqN__"